import React, { useState } from "react";
import { API } from "@/lib/api";

/**
 * Inline "Notify me when this brand becomes readable" form, shown inside the
 * ACCESS_RESTRICTED banner. Double opt-in — we tell the user to check their
 * inbox after submit and never confirm without the magic-link click.
 */
export default function NotifyWhenReadable({ brandSlug, locale, t }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  async function onSubmit(e) {
    e.preventDefault();
    if (!email.includes("@")) {
      setState({ status: "error", message: t.notify_when_readable_invalid_email });
      return;
    }
    setState({ status: "submitting", message: "" });
    try {
      const res = await fetch(`${API}/access-restricted/watch`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ brand_slug: brandSlug, email, locale }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        setState({
          status: "error",
          message: body.detail || t.notify_when_readable_error,
        });
        return;
      }
      const data = await res.json();
      if (data.status === "already_confirmed") {
        setState({ status: "success", message: t.notify_when_readable_already });
      } else if (data.status === "already_notified") {
        setState({ status: "success", message: t.notify_when_readable_already });
      } else {
        setState({ status: "success", message: t.notify_when_readable_success });
      }
      setEmail("");
    } catch (err) {
      setState({ status: "error", message: t.notify_when_readable_error });
    }
  }

  if (state.status === "success") {
    return (
      <div className="mt-4 text-sm" style={{ color: "#2A3E56" }} data-testid="notify-when-readable-success">
        {state.message}
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      className="mt-4 flex flex-col sm:flex-row gap-2"
      data-testid="notify-when-readable-form"
    >
      <input
        type="email"
        required
        placeholder={t.notify_when_readable_placeholder}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 px-3 py-2 text-sm border bg-white"
        style={{ borderColor: "#5A7A9A", color: "#1A1A18" }}
        data-testid="notify-when-readable-email-input"
      />
      <button
        type="submit"
        disabled={state.status === "submitting"}
        className="px-4 py-2 text-sm font-medium disabled:opacity-60"
        style={{ background: "#2A3E56", color: "#fff" }}
        data-testid="notify-when-readable-submit"
      >
        {state.status === "submitting"
          ? t.notify_when_readable_submitting
          : t.notify_when_readable_cta}
      </button>
      {state.status === "error" && (
        <div className="text-xs mt-1 sm:mt-0 sm:ml-2 self-center" style={{ color: "#B7462F" }} data-testid="notify-when-readable-error">
          {state.message}
        </div>
      )}
    </form>
  );
}
